/*
 * Helper functions
 */
//From http://www.quirksmode.org/js/events_properties.html#position
const getMousePosition = (e) => {

	// Default position
	let posx = 0;
	let posy = 0;

	// Fallbacks
	if (!e) {
		e = window.event
	}

	if (e.pageX || e.pageY) {
		posx = e.pageX;
		posy = e.pageY;
	} else if (e.clientX || e.clientY) 	{
		posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
		posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
	}

	return { x : posx, y : posy }
}

const imageHover = (() => {
	const ih = {
		images: [],
	}

	ih.init = () => {
		let hoverItems = document.querySelectorAll('.mouse-trail');

		if(!hoverItems || !hoverItems.length)
		{
			return false;
		}

		ih.images = hoverItems;

		ih.images.forEach((item) => {
			ih._animateLink(item);
		});
	}

	ih._animateLink = (item) => {
		createImageCursor(item);
	}

	return ih;
})();

export default imageHover;

const createImageCursor = (el) =>
{
	const instance = {
		element: undefined,
		className: undefined,
		elInner: undefined,
		imageWrapper: undefined,
		image: undefined,
		breakpoint: window.matchMedia('(max-width: 980px)'),
	}

	const positionElement = (event) => {
		const mousePos = getMousePosition(event);
		const docPos = {
			left : document.body.scrollLeft + document.documentElement.scrollLeft,
			top : document.body.scrollTop + document.documentElement.scrollTop,
		};

		// Image dimensions are set widths
		const imageOffsetY = 170;
		const imageOffsetX = 125;

		Object.assign(instance.imageWrapper.style,{
			left: `${(mousePos.x - docPos.left) - imageOffsetX}px`,
			top: `${(mousePos.y - docPos.top) - imageOffsetY}px`,
		});
	};

	const handleMouseEnter = (ev) => {
		positionElement(ev);
		instance.showImage();
	};

	const handleMouseMove = ev => requestAnimationFrame(() => {
		positionElement(ev);
	});

	const handleMouseleave = () => {
		instance.hideImage();
	};

	const handleHidingComplete = () => {
		instance.element.style.removeProperty('z-index');
	}

	instance.init = (el) => {
		console.log(instance.breakpoint.matches)
		if(!el || el === undefined)
		{
			return false;
		}

		instance.element = el;
		instance.imageWrapper = instance.element.querySelector('.mouse-trail__image');
		instance.jImageWrapper = $(instance).find('.mouse-trail__image');
		instance.className = 'mouse-trail__image';
		instance.image = instance.element.querySelector('img');
		instance.elInner = instance.element.querySelector('.mouse-trail__inner');
		instance.elInner.style.overflow = 'hidden';

		instance.animateImage();
	}

	instance.showImage = () => {
		instance.imageWrapper.style.opacity = 1;
	}

	instance.hideImage = () => {
		instance.imageWrapper.style.opacity = 0;
	}

	instance.animateImage = () => {
		instance.element.addEventListener('mouseenter', handleMouseEnter);
		instance.element.addEventListener('mousemove', handleMouseMove);
		instance.element.addEventListener('mouseleave', handleMouseleave);
		instance.imageWrapper.addEventListener('transitionend', handleHidingComplete);
	}

	instance.unload = () => {
		if(instance.element === undefined)
		{
			return;
		}

		instance.element.removeEventListener('mouseenter', handleMouseEnter);
		instance.element.removeEventListener('mousemove', handleMouseMove);
		instance.element.removeEventListener('mouseleave', handleMouseleave);
		instance.imageWrapper.removeEventListener('transitionend', handleHidingComplete);
	}

	instance.isTablet = () => {
		if(instance.breakpoint.matches) {
			instance.unload(el)
		} else {
			instance.init(el);
		}
	}

	// Add the match function as a listener for state changes:
	instance.breakpoint.addEventListener('change', instance.isTablet);
	instance.init(el);
}



// WEBPACK FOOTER //
// ./scripts/modules/image-mouse-hover.js